import React, { useEffect, useRef, useState } from "react";
import "../../../Static/priceinfo.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Paper,
  Button,
  useMediaQuery
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReactToPrint from "react-to-print";
import { fetchSOMaterialList } from "../../../Store/PHPSlice/Sale/SaleOrder";
import {
  selectSONOMaterailInfoList,
  selectSONOinfolist
} from "../../Selectors/Master/ItemSelectors";
import FirmHeaderImg from "../../FieldsComponents/FirmHeaderImg";

const SOMaterialInfo = () => {
  const { Id } = useParams();
  const dispatch = useDispatch();

  // 🔹 Sale Order basic info
  const soinfolist = useSelector(selectSONOinfolist);

  // 🔹 Material + infoData
  const materialInfo = useSelector(selectSONOMaterailInfoList);

  const componentRef = useRef();
  const isDesktop = useMediaQuery("(min-width:768px)");

  const [formData, setFormData] = useState({
    partyNm: "",
    sono: "",
    orderno: "",
    adrs: "",
    gst: "",
    dt: "",
    firmId: ""
  });

  useEffect(() => {
    dispatch(fetchSOMaterialList(Id));
  }, [Id, dispatch]);

  // 🔹 Set header info
  useEffect(() => {
    if (soinfolist?.data?.length) {
      const item = soinfolist.data[0];
      setFormData({
        partyNm: item.partyNm,
        sono: item.sono,
        orderno: item.orderno,
        adrs: item.adrs,
        gst: item.gst,
        dt: item.ordt,
        firmId: item.firmId
      });
    }
  }, [soinfolist]);

  // console.log(materialInfo);
  return (
    <Grid item xs={12}>
      <Paper sx={{ p: 3 }}>
        <div ref={componentRef}>
          {formData.firmId && <FirmHeaderImg firmId={formData.firmId} />}

          <h3 className="centered-heading">Sale Order Material Info</h3>
          <div className="dashed-line" />

          {/* ===== BASIC INFO ===== */}
          {/* <table style={{ margin: "1% 5%", fontSize: "14px" }}>
            <tbody>
              <tr>
                <td>Party Name</td><td>:</td><td>{formData.partyNm}</td>
                <td>Sale Order No</td><td>:</td><td>{formData.sono}</td>
              </tr>
              <tr>
                <td>Order No</td><td>:</td><td>{formData.orderno}</td>
                <td>Date</td><td>:</td><td>{formData.dt}</td>
              </tr>
              <tr>
                <td>Address</td><td>:</td><td>{formData.adrs}</td>
                <td>GST</td><td>:</td><td>{formData.gst}</td>
              </tr>
            </tbody>
          </table> */}

          {/* ===== MATERIAL TABLES ===== */}
          {materialInfo?.data?.map((material, idx) => {
            const matId = material.matId;
            const rows =
              materialInfo?.infoData?.[matId]?.info_soId || [];

            if (!rows.length) return null;

            const totals = rows.reduce(
              (t, r) => {
                t.inch += parseFloat(r.totalInch || 0);
                t.mtr += parseFloat(r.totalMtr || 0);
                t.mqty += parseFloat(r.mqty || 0);
                return t;
              },
              { inch: 0, mtr: 0, mqty: 0 }
            );

            return (
              <TableContainer
                key={idx}
                component={Paper}
                sx={{
                  width: isDesktop ? "90%" : "100%",
                  m: "25px auto"
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #444", fontWeight: "bold" }}>
                        Material Name
                      </TableCell>
                      <TableCell sx={{ border: "1px solid #444", fontWeight: "bold" }}>
                        Size
                      </TableCell>
                      {rows.map((r, i) => (
                        <TableCell
                          key={i}
                          align="center"
                          sx={{ border: "1px solid #444", fontWeight: "bold" }}
                        >
                          {r.size}
                        </TableCell>
                      ))}
                      <TableCell
                        align="center"
                        sx={{ border: "1px solid #444", fontWeight: "bold" }}
                      >
                        Total
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {/* ITEM LENGTH */}
                    <TableRow>
                      <TableCell
                        rowSpan={6}
                        sx={{
                          border: "1px solid #444",
                          fontWeight: "bold",
                          verticalAlign: "top"
                        }}
                      >
                        {material.materialNm}
                        <br />
                        <small>({material.mtype})</small>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #444" }}>
                        Material Size
                      </TableCell>
                      {rows.map((r, i) => (
                        <TableCell
                          key={i}
                          align="center"
                          sx={{ border: "1px solid #444" }}
                        >
                          {r.matsize}
                        </TableCell>
                      ))}
                      <TableCell sx={{ border: "1px solid #444" }} />
                    </TableRow>
                    {/* material qty */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #444" }}>Material Qty</TableCell>
                      {rows.map((r, i) => (
                        <TableCell
                          key={i}
                          align="center"
                          sx={{ border: "1px solid #444" }}
                        >
                          {r.matgqty}
                        </TableCell>
                      ))}
                      <TableCell sx={{ border: "1px solid #444" }} />
                    </TableRow>

                    {/* QTY */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #444" }}>Qty</TableCell>
                      {rows.map((r, i) => (
                        <TableCell
                          key={i}
                          align="center"
                          sx={{ border: "1px solid #444" }}
                        >
                          {r.qty}
                        </TableCell>
                      ))}
                      <TableCell sx={{ border: "1px solid #444" }} />
                    </TableRow>

                    {/* required total qty */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #444" }}>Total Req. Qty</TableCell>
                      {rows.map((r, i) => (
                        <TableCell
                          key={i}
                          align="center"
                          sx={{ border: "1px solid #444" }}
                        >
                          {r.mqty}
                        </TableCell>
                      ))}
                      <TableCell
                        align="center"
                        sx={{ border: "1px solid #444", fontWeight: "bold" }}
                      >
                        {totals.mqty.toFixed(2)}
                      </TableCell>
                    </TableRow>

                    {/* INCH */}
                    <TableRow sx={{ background: "#e8f5e9" }}>
                      <TableCell sx={{ border: "1px solid #444", fontWeight: "bold" }}>
                        Inch
                      </TableCell>
                      {rows.map((r, i) => (
                        <TableCell
                          key={i}
                          align="center"
                          sx={{ border: "1px solid #444" }}
                        >
                          {r.totalInch}
                        </TableCell>
                      ))}
                      <TableCell
                        align="center"
                        sx={{ border: "1px solid #444", fontWeight: "bold" }}
                      >
                        {totals.inch.toFixed(2)}
                      </TableCell>
                    </TableRow>

                    {/* METER */}
                    <TableRow sx={{ background: "#fff3e0" }}>
                      <TableCell sx={{ border: "1px solid #444", fontWeight: "bold" }}>
                        Meter
                      </TableCell>
                      {rows.map((r, i) => (
                        <TableCell
                          key={i}
                          align="center"
                          sx={{ border: "1px solid #444" }}
                        >
                          {r.totalMtr}
                        </TableCell>
                      ))}
                      <TableCell
                        align="center"
                        sx={{ border: "1px solid #444", fontWeight: "bold" }}
                      >
                        {totals.mtr.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            );
          })}
        </div>

        <div style={{ margin: "2% 5%" }}>
          <ReactToPrint
            trigger={() => <Button variant="contained">Print</Button>}
            content={() => componentRef.current}
          />
        </div>
      </Paper>
    </Grid>
  );
};

export default SOMaterialInfo;
